export default __webpack_public_path__ + "static/ma-gleason-balthazaurus-scroll-86d75acfe800030b93b2b3eb32a50a2e.gif";